import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class SolutionDescriptionQueryService {

    private CREATE_NEW_SOLUTION_DESCRIPTION: any;

    private GET_FIRST_SOLUTION_DESCRIPTION: any;
    private GET_NEXT_SOLUTION_DESCRIPTION: any;

    private SEARCH_SOLUTIONS_BY_FILTER_OPTIONS: any;
    private SEARCH_KEYWORD_IS_PRESENT: any;

    private GET_SUGGESTIONS_WORDS:any;

    private SEARCH_SOLUTIONS_EXISTED:any;
    private UPDATE_SOLUTION_DESCRIPTION_BY_ID: any;
    private DELETE_SOLUTION_DESCRIPTION_BY_ID: any;

    private allSolutionDescriptionsFragments:string;
    SEARCH_SOLUTIONS_PRIMARY_BY_FILTER_OPTIONS: any;
    

    constructor(public apollo: Apollo) {

        this.allSolutionDescriptionsFragments=gql`
            fragment SolutionDescriptionFields on SolutionDescription  {
                id
                solution
                cost
                keyword
                keyPrimCategory
                subcategory
                key1
                keyPhrase
                key2
                key3
                key4
                irl
                costOption
                labourCost
                hourRate
                laborHour
                materialCost
                ni
                tf
                cpi
                cpf
                totalCost
            }
            `;

        //Create inspection report  detail
        this.CREATE_NEW_SOLUTION_DESCRIPTION = gql` 
         mutation createCategory($input:CreateSolutionDescriptionInput!)
         {
            createSolutionDescription(input:$input){
                        solutionDescription{
                           id
                        }
            }
         }
       `;

      

        /*Get five schedules data */
        this.GET_FIRST_SOLUTION_DESCRIPTION = gql`
            query {
                allSolutionDescriptions(first:10,orderBy:ID_DESC) {
                    edges {
                        node {
                                ...SolutionDescriptionFields,
                            
                            }
                                cursor
                    }
                            pageInfo
                            {
                                startCursor
                                endCursor
                                hasNextPage
                            }
                                totalCount
                  }
            }
            ${this.allSolutionDescriptionsFragments}
        `;

         /*Get five schedules data */
         this.GET_NEXT_SOLUTION_DESCRIPTION = gql`
         query getSolutions($cursor: Cursor!){
             allSolutionDescriptions(after: $cursor, first: 10, orderBy: ID_DESC) {
                 edges {
                     node {
                           ...SolutionDescriptionFields,
                            
                         }
                             cursor
                 }
                         pageInfo
                         {
                             startCursor
                             endCursor
                             hasNextPage
                         }
                             totalCount  
               }
         }
         ${this.allSolutionDescriptionsFragments}
     `;
 
     this.GET_SUGGESTIONS_WORDS= gql`
            query wordsuggestions($word:String,$type:String){
                wordSuggestions(pSearchStr:$word,pType:$type)
            }
     `;

    

        this.SEARCH_SOLUTIONS_BY_FILTER_OPTIONS= gql`
        query searchDescription($keyPrimCategory: String, $subcategory: String, 
            $key1:String,$key2:String,$key3:String,$key4:String) {
            allSolutionDescriptions(filter: 
                {
                    keyPrimCategory: {includesInsensitive: $keyPrimCategory}, 
                    subcategory: {includesInsensitive: $subcategory},
                  and:[{or:[ {key1:{includesInsensitive:$key1}},{key2:{includesInsensitive:$key1}},{key3:{includesInsensitive:$key1}},{key4:{includesInsensitive:$key1}}]},
                      {or:[ {key1:{includesInsensitive:$key2}},{key2:{includesInsensitive:$key2}},{key3:{includesInsensitive:$key2}},{key4:{includesInsensitive:$key2}}]},
                      {or:[ {key1:{includesInsensitive:$key3}},{key2:{includesInsensitive:$key3}},{key3:{includesInsensitive:$key3}},{key4:{includesInsensitive:$key3}}]},
                      {or:[ {key1:{includesInsensitive:$key4}},{key2:{includesInsensitive:$key4}},{key3:{includesInsensitive:$key4}},{key4:{includesInsensitive:$key4}}]},

                  ]
                    
                },orderBy:ID_DESC)   {
                nodes {
                    ...SolutionDescriptionFields
                }
            }
            }
            ${this.allSolutionDescriptionsFragments}
        `;

        this.SEARCH_KEYWORD_IS_PRESENT= gql`
        query searchDescription($word: String) {
            allSolutionDescriptions(filter: 
                {
                   or:[{keyPrimCategory: {includesInsensitive: $word}},
                    {key1:{includesInsensitive:$word}},
                    {key2:{includesInsensitive:$word}},
                    {key3:{includesInsensitive:$word}},
                    {key4:{includesInsensitive:$word}}]
                }) {
                nodes {
                    keyPrimCategory
                }
            }
            }
        `;

        this.SEARCH_SOLUTIONS_PRIMARY_BY_FILTER_OPTIONS= gql`
        query searchPrimarycategory($keyPrimCategory: String) {
            allSolutionDescriptions(filter: 
                {
                    keyPrimCategory: {includesInsensitive: $keyPrimCategory},
                },orderBy:ID_DESC)   {
                nodes {
                    ...SolutionDescriptionFields
                }
            }
            }
            ${this.allSolutionDescriptionsFragments}
        `;

        this.SEARCH_SOLUTIONS_EXISTED= gql`
        query searchDescription($keyPrimCategory: String!, $keyPhrase: String!, 
            $key1: String, $key2: String, $key3: String,$key4: String,$solution: String,$totalCost:BigFloat) {
            allSolutionDescriptions(filter: 
                {
                    keyPrimCategory: {includesInsensitive: $keyPrimCategory}, 
                    keyPhrase: {equalTo: $keyPhrase},
                    key1: {equalTo: $key1},
                    key2: {equalTo: $key2},
                    key3: {equalTo: $key3},
                    key4: {equalTo: $key4},
                    solution:{equalTo: $solution}
                    totalCost:{equalTo: $totalCost}
                }) {
                nodes {
                    id
                }
            }
            }
        `;


        this.UPDATE_SOLUTION_DESCRIPTION_BY_ID = gql`
            mutation UPDATE_SOLUTION_DESCRIPTION_BY_ID($input: UpdateSolutionDescriptionByIdInput!) {
                updateSolutionDescriptionById(input: $input) {
                    solutionDescriptionEdge {
                        node {
                            id
                        }
                    }
                }
            }
      `;

        this.DELETE_SOLUTION_DESCRIPTION_BY_ID = gql`
            mutation DELETE_SOLUTION_DESCRIPTION_BY_ID($input: DeleteSolutionDescriptionByIdInput!) {
                deleteSolutionDescriptionById(input:$input){
                   deletedSolutionDescriptionId
                }
            }
       `;

    }

    // Uplaod logo
    CREATE_SOLUTION_DESCRIPTION(solution) {
        return this.apollo.mutate({
            mutation: this.CREATE_NEW_SOLUTION_DESCRIPTION,
            variables: {
                "input": {
                    "solutionDescription": {
                        "keyword": solution.keyword,
                        "solution": solution.solution,
                        "cost": solution.cost,
                        "keyPrimCategory": solution.keyPrimCategory,
                        "subcategory": solution.subcategory,
                        "key1": solution.key1,
                        "keyPhrase": solution.keyPhrase,
                        "key2": solution.key2,
                        "key3": solution.key3,
                        "key4": solution.key4,
                        "costOption": solution.costOption,
                        "labourCost": Number.parseFloat(solution.labourCost),
                        "hourRate":Number.parseInt( solution.hourRate),
                        "laborHour": Number.parseInt(solution.laborHour),
                        "materialCost":Number.parseFloat(solution.materialCost),
                        "ni":Number.parseFloat(solution.ni) ,
                        "tf": Number.parseFloat(solution.tf),
                        "cpi": Number.parseFloat(solution.cpi),
                        "cpf": Number.parseFloat(solution.cpf),
                        "totalCost":Number.parseFloat(solution.totalCost),
                        "irl":solution.irl,
                    }
                }
            },
        })
    }

    

    // GET SOLUTION DESCRIPTION
    GET_SOLUTION_DESCRIPTION_BY_FILTER_OPTION(solution) {
        return this.apollo.watchQuery({
            query: this.SEARCH_SOLUTIONS_BY_FILTER_OPTIONS,
            variables:
            {
                "keyPrimCategory":solution.keyPrimCategory,
                // "keyword": solution.keyword,
                "subcategory":solution.subcategory,
                "key1": solution.key1,
                "key2": solution.key2,
                "key3": solution.key3,
                "key4": solution.key4,
            },
            fetchPolicy: 'network-only'
        })
    }
    // GET SOLUTION DESCRIPTION
    GET_PRIMARY_SOLUTION_BY_FILTER_OPTION(solution) {
        return this.apollo.watchQuery({
            query: this.SEARCH_SOLUTIONS_PRIMARY_BY_FILTER_OPTIONS,
            variables:
            {
                "keyPrimCategory":solution.keyPrimCategory,
            },
            fetchPolicy: 'network-only'
        })
    }

    // GET SOLUTION DESCRIPTION
    GET_WORD_SUGGESSTIONS_BY_FILTER_OPTION(word,type) {
        return this.apollo.watchQuery({
            query: this.GET_SUGGESTIONS_WORDS,
            variables:
            {
                "word":word,
                "type":type,
            },
            fetchPolicy: 'network-only'
        })
    }

    CHECK_SEARCH_KEYWORD_IS_PRESENT(word){
        return this.apollo.watchQuery({
            query: this.SEARCH_KEYWORD_IS_PRESENT,
            variables:
            {
                "word":word
            },
            fetchPolicy: 'network-only'
        })
    }

    // GET SOLUTION DESCRIPTION
    CHECK_SOLUTION_DESCRIPTION_EXISTED(solution) {
        return this.apollo.watchQuery({
            query: this.SEARCH_SOLUTIONS_EXISTED,
            variables:
            {
                "keyPrimCategory":solution.keyPrimCategory,
                "keyPhrase":solution.keyPhrase,
                "key1":solution.key1,
                "key2":solution.key2,
                "key3":solution.key3,
                "key4":solution.key4,
                "solution":solution.solution,
                "totalCost":Number.parseFloat(solution.totalCost)
            },
            fetchPolicy: 'network-only'
        })
    }

    /*Get all schedules data */
    GET_SOLUTION_DESCRIPTION_BY_LIMIT(from, cursor): any {
        console.log('from', from);
        return this.apollo.watchQuery({
            query: from == 'initial' ? this.GET_FIRST_SOLUTION_DESCRIPTION : this.GET_NEXT_SOLUTION_DESCRIPTION,
            variables:
            {
                "cursor": cursor,
            },
            fetchPolicy: 'network-only'
        });
    }

    UPDATE_SOLUTION_DESCRIPTION(solution) {
        return this.apollo.mutate({
            mutation: this.UPDATE_SOLUTION_DESCRIPTION_BY_ID,
            variables: {

                "input": {
                    "id": solution.id,
                    "solutionDescriptionPatch":
                    {
                        "keyword": solution.keyword,
                        "solution": solution.solution,
                        "cost": solution.cost,
                        "keyPrimCategory": solution.keyPrimCategory,
                        "subcategory":solution.subcategory,
                        "key1": solution.key1,
                        "keyPhrase": solution.keyPhrase,
                        "key2": solution.key2,
                        "key3": solution.key3,
                        "key4": solution.key4,
                        "costOption": solution.costOption,
                        "labourCost": Number.parseFloat(solution.labourCost),
                        "hourRate":Number.parseInt( solution.hourRate),
                        "laborHour": Number.parseInt(solution.laborHour),
                        "materialCost":Number.parseFloat(solution.materialCost),
                        "ni":Number.parseFloat(solution.ni) ,
                        "tf": Number.parseFloat(solution.tf),
                        "cpi": Number.parseFloat(solution.cpi),
                        "cpf": Number.parseFloat(solution.cpf),
                        "totalCost":Number.parseFloat(solution.totalCost),
                        "irl":solution.irl,
                    }
                }
            },
            fetchPolicy: 'no-cache'
        })
    }

    //Delete Selected company data
    DELETE_SOLUTION_DESCRIPTION(solutionId) {
        return this.apollo.mutate({
            mutation: this.DELETE_SOLUTION_DESCRIPTION_BY_ID,
            variables: {
                "input": {
                    "id": solutionId
                }
            }
        })
    }

}




// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/queryFiles/solutionDescription.ts